export default __webpack_public_path__ + "74e9fe3d9ced3f6712fe8e987b109292.png";